import styled from 'styled-components'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Headline = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp12};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.radius.card};
  background-color: ${props => props.theme.colors.success.surface};
`

export const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: ${props => props.theme.spacing.sp16};

  @media (max-width: 1120px) {
    gap: ${props => props.theme.spacing.sp8};
  }
`
